export type OverlayEventDetail = {
  id?: string;
};

export enum CustomEventEnum {
  OverlayPrioritize = "overlay:prioritize",
  OverlayDeprioritize = "overlay:deprioritize",
}

export interface CustomEventMap {
  [CustomEventEnum.OverlayPrioritize]: CustomEvent<OverlayEventDetail>;
  [CustomEventEnum.OverlayDeprioritize]: CustomEvent<OverlayEventDetail>;
}
